/**
 * bootprompt.js locale configuration
 * locale : Chinese (China / People's Republic of China)
 * author : Nick Payne
 */

import { addLocale } from "../bootprompt";

addLocale("zh_CN", {
  OK: "OK",
  CANCEL: "取消",
  CONFIRM: "确认",
});
